import { render, staticRenderFns } from "./ArrowLeft.vue?vue&type=template&id=69239b64&"
import script from "./ArrowLeft.vue?vue&type=script&lang=js&"
export * from "./ArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports